{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024-2025                                 }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCDataGridBase;

interface

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}

uses
  {$IFDEF MSWINDOWS}
  Windows,
  {$ENDIF}
  Classes, WEBLib.TMSFNCCustomControl, WEBLib.Controls, WEBLib.TMSFNCDataGridRenderer, WEBLib.TMSFNCDataGridData, WEBLib.TMSFNCDataGridCore,
  WEBLib.TMSFNCTypes, Types, Generics.Collections
  {$IFNDEF WEBLIB}
  ,UITypes
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,SysUtils
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,Messages
  {$ENDIF}
  ;

type
  TTMSFNCDataGridBase = class;

  TTMSFNCDataGridBase = class(TTMSFNCCustomControl)
  private
    FUpdateCount: Integer;
    FRoot: TTMSFNCDataGridRenderer;
    FRootPersistence: Integer;
    function GetRoot: TTMSFNCDataGridRenderer;
  protected
    function GetCalculationRect: TRectF; virtual;
    function GetRendererClass: TTMSFNCDataGridRendererClass; virtual;
    function DoRootIsDestroying(Sender: TObject): Boolean; virtual;
    function DoRootIsLoading(Sender: TObject): Boolean; virtual;
    function DoRootIsFocused(Sender: TObject): Boolean; virtual;
    function DoRootIsDesigntime(Sender: TObject): Boolean; virtual;

    procedure AfterExport; override;
    procedure BeforeExport; override;
    procedure SetExportRect(ARect: TRectF); override;
    procedure ApplyExportScale(AScale: Single); override;
    procedure ResetExportScale; override;
    procedure DoRootDisplay(Sender: TObject); virtual;
    procedure DoRootResetCapture(Sender: TObject); virtual;
    procedure DoRootFocus(Sender: TObject); virtual;
    procedure DoRootAfterCalculate(Sender: TObject); virtual;
    procedure DoRootBeforeCalculate(Sender: TObject); virtual;
    procedure DoRootUpdateCursor(Sender: TObject; ACursor: TCursor); virtual;
    procedure Loaded; override;
    procedure InvalidateGrid;
    procedure UpdateControlAfterResize; override;
    procedure UpdateRoot;
    procedure ExportNotification(AState: TTMSFNCDataGridExportState; ARow: Integer); virtual;
    procedure ImportNotification(AState: TTMSFNCDataGridImportState; ARow: Integer); virtual;

    property UpdateCount: Integer read FUpdateCount;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;

    procedure BeginUpdate; override;
    procedure Clear; virtual;
    procedure ClearData; virtual;
    procedure RefreshData(ACell: TTMSFNCDataGridCellCoord; AUpdate: Boolean = True); overload; virtual;
    procedure RefreshData(ACellRange: TTMSFNCDataGridCellCoordRange; AUpdate: Boolean = True); overload; virtual;
    procedure RefreshData(AUpdate: Boolean = True); overload; virtual;
    procedure EndUpdate; override;

    property Root: TTMSFNCDataGridRenderer read GetRoot;
    property RootPersistence: Integer read FRootPersistence write FRootPersistence default 0;
  end;

implementation

uses
  DateUtils, WEBLib.TMSFNCDataGridCell, WEBLib.Forms, Math, WEBLib.TMSFNCUtils
  {$IFNDEF WEBLIB}
  ,SysUtils
  {$ENDIF}
  {$IFDEF FMXLIB}
  ,FMX.Types
  {$ENDIF}
  ;

{ TTMSFNCDataGridBase }

procedure TTMSFNCDataGridBase.AfterExport;
begin
  inherited;
  Root.AfterExport;
end;

procedure TTMSFNCDataGridBase.ResetExportScale;
begin
  Root.ResetExportScale;
end;

procedure TTMSFNCDataGridBase.ApplyExportScale(AScale: Single);
begin
  inherited;
  Root.ApplyExportScale(AScale);
end;

procedure TTMSFNCDataGridBase.BeforeExport;
begin
  inherited;
  Root.BeforeExport;
end;

procedure TTMSFNCDataGridBase.BeginUpdate;
begin
  inherited;
  Root.BeginUpdate;
  Inc(FUpdateCount);
end;

procedure TTMSFNCDataGridBase.Clear;
begin
  Root.Clear;
end;

procedure TTMSFNCDataGridBase.ClearData;
begin
  Root.ClearData;
end;

constructor TTMSFNCDataGridBase.Create(AOwner: TComponent);
begin
  inherited;
  FRootPersistence := 0;
end;

destructor TTMSFNCDataGridBase.Destroy;
begin
  FreeAndNil(FRoot);
  inherited;
end;

procedure TTMSFNCDataGridBase.DoRootAfterCalculate(Sender: TObject);
begin

end;

procedure TTMSFNCDataGridBase.DoRootBeforeCalculate(Sender: TObject);
begin

end;

procedure TTMSFNCDataGridBase.DoRootDisplay(Sender: TObject);
begin
  InvalidateGrid;
end;

procedure TTMSFNCDataGridBase.DoRootResetCapture(Sender: TObject);
begin
  ReleaseCaptureEx;
end;

procedure TTMSFNCDataGridBase.DoRootFocus(Sender: TObject);
begin
end;

function TTMSFNCDataGridBase.DoRootIsDesigntime(Sender: TObject): Boolean;
begin
  Result := IsDesigntime;
end;

function TTMSFNCDataGridBase.DoRootIsDestroying(Sender: TObject): Boolean;
begin
  Result := IsDestroying;
end;

function TTMSFNCDataGridBase.DoRootIsFocused(Sender: TObject): Boolean;
begin
  Result := IsFocused;
end;

function TTMSFNCDataGridBase.DoRootIsLoading(Sender: TObject): Boolean;
begin
  Result := IsLoading;
end;

procedure TTMSFNCDataGridBase.DoRootUpdateCursor(Sender: TObject;
  ACursor: TCursor);
begin

end;

function TTMSFNCDataGridBase.GetCalculationRect: TRectF;
begin
  Result := LocalRect;
end;

function TTMSFNCDataGridBase.GetRendererClass: TTMSFNCDataGridRendererClass;
begin
  Result := TTMSFNCDataGridRenderer;
end;

function TTMSFNCDataGridBase.GetRoot: TTMSFNCDataGridRenderer;
begin
  if not Assigned(FRoot) then
  begin
    FRoot := GetRendererClass.Create(Self);
    FRoot.Name := 'Root';
  end;

  Result := FRoot;
end;

procedure TTMSFNCDataGridBase.ImportNotification(
  AState: TTMSFNCDataGridImportState; ARow: Integer);
begin
  Root.ImportNotification(AState, ARow);
end;

procedure TTMSFNCDataGridBase.Loaded;
begin
  inherited;
  UpdateRoot;
end;

procedure TTMSFNCDataGridBase.EndUpdate;
begin
  inherited;
  Dec(FUpdateCount);
  Root.EndUpdate;
end;

procedure TTMSFNCDataGridBase.ExportNotification(
  AState: TTMSFNCDataGridExportState; ARow: Integer);
begin
  Root.ExportNotification(AState, ARow);
  {$IFDEF VCLLIB}
  if AState = gesExportStart then
    SendMessage(Handle, WM_SETREDRAW, 0, 0);

  if AState = gesExportDone then
  begin
    SendMessage(Handle, WM_SETREDRAW, 1, 0);
    RedrawWindow(Handle, nil, 0, RDW_ERASE or RDW_INVALIDATE or RDW_FRAME or RDW_ALLCHILDREN);
  end;
  {$ENDIF}
end;

procedure TTMSFNCDataGridBase.RefreshData(ACell: TTMSFNCDataGridCellCoord;
  AUpdate: Boolean);
begin
  Root.RefreshData(ACell, AUpdate);
end;

procedure TTMSFNCDataGridBase.RefreshData(
  ACellRange: TTMSFNCDataGridCellCoordRange; AUpdate: Boolean);
begin
  Root.RefreshData(ACellRange, AUpdate);
end;

procedure TTMSFNCDataGridBase.RefreshData(AUpdate: Boolean);
begin
  Root.RefreshData(AUpdate);
end;

procedure TTMSFNCDataGridBase.InvalidateGrid;
begin
  Invalidate;
end;

procedure TTMSFNCDataGridBase.SetExportRect(ARect: TRectF);
begin
  inherited;
  Root.SetExportRect(ARect);
end;

procedure TTMSFNCDataGridBase.UpdateControlAfterResize;
begin
  inherited;
  UpdateRoot;
end;

procedure TTMSFNCDataGridBase.UpdateRoot;
var
  r: TRectF;
begin
  r := GetCalculationRect;
  Root.SetLocalRect(r);
  Root.Update;
end;

end.
